import React from "react";
import { Subscribe } from 'unstated';
import OrganizationContainer from "../../state/containers/OrganizationContainer";
import MediaContainer from "../../state/containers/MediaContainer";
import DeploymentAccountsContainer from "../../state/containers/DeploymentAccountsContainer";
import ApiKeyContainer from "../../state/containers/ApiKeyContainer";
import MemberContainer from "../../state/containers/MemberContainer";
import UserContainer from "../../state/containers/UserContainer";
import ApplicationContainer from "../../state/containers/ApplicationContainer";
import AppliedApplicationTemplateContainer from "../../state/containers/AppliedApplicationTemplateContainer";
import ApplicationEnvironmentsContainer from "../../state/containers/ApplicationEnvironmentsContainer";
import OrganizationSettingsTabs from "./components/OrganizationSettingsTabs";

interface OrganizationSettingsProps {
    history: any
}

const OrganizationSettings: React.FC<OrganizationSettingsProps> = (props) => (
    <Subscribe to={[OrganizationContainer, MediaContainer, DeploymentAccountsContainer, ApiKeyContainer, MemberContainer, UserContainer, ApplicationContainer, AppliedApplicationTemplateContainer, ApplicationEnvironmentsContainer]}>
        {(orgContainer: OrganizationContainer, mediaContainer: MediaContainer, deploymentContainer: DeploymentAccountsContainer, apiKeyContainer: ApiKeyContainer, memberContainer: MemberContainer, userContainer: UserContainer, applicationContainer: ApplicationContainer, appliedTemplateContainer: AppliedApplicationTemplateContainer, applicationEnvironmentsContainer: ApplicationEnvironmentsContainer) => {
            return (
                <OrganizationSettingsTabs
                    history={props.history}
                    orgContainer={orgContainer}
                    mediaContainer={mediaContainer}
                    memberContainer={memberContainer}
                    deploymentContainer={deploymentContainer}
                    apiKeyContainer={apiKeyContainer}
                    userContainer={userContainer}
                    applicationContainer={applicationContainer}
                    appliedTemplateContainer={appliedTemplateContainer}
                    applicationEnvironmentsContainer={applicationEnvironmentsContainer} />
            );
        }}
    </Subscribe>
);

export default OrganizationSettings;